(ns frontend.ui.component.lp-portal.report.tearsheet.portfolio-by-country-at-fair-value.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn portfolio-by-country-at-fair-value-card
  [{:keys [rich-content rich-content-path figures] :as data}
   {:keys [edit-mode? save-text] :as props}]
  [card {:title "Portfolio by Country at Fair Value"}
   [:<>
    [chart (:figures data)]
    (text-content/optional-footnote data props)]])
